<template>
    <v-dialog v-model="isShow" :persistent="persistent" :max-width="width">
        <v-card>
            <v-card-title class="headline">{{ title }}</v-card-title>
            <v-card-text>{{ message }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="!isOkayOnly" color="default darken-1" text @click="onCancel">{{ cancelText }}</v-btn>
                <v-btn
                    :color="color + ' darken-1'"
                    :disabled="isProcessing"
                    text
                    @click="onOk">
                    <span v-if="isProcessing">
                        <v-progress-circular
                            indeterminate
                            size="12"
                            width="2"
                            color="error darken-3">
                        </v-progress-circular>
                        Please wait...
                    </span>
                    <span v-else>
                        {{ okText }}
                    </span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>


export default {

    props: {
        width: { type: String, default: '290' },
        color: { type: String, default: 'light' },
        okText: { type: String, default: 'Ok' },
        cancelText: { type: String, default: 'Cancel' },
        isOkayOnly: { type: Boolean, default: false },
        persistent: { type: Boolean, default: true }
    },

    data() {
        return {
            isShow: false,
            title: '',
            message: '',
            isProcessing: false,
            callback: () => {},
            cancelCB: () => {}
        }
    },

    methods: {
        // this function accepts title and message of the modal to show
        // cb is the callback function to execute after ok button clicked
        onShow(title, message, cb, cancel = null) {
            this.isShow   = true
            this.title    = title
            this.message  = message
            this.callback = cb
            this.cancelCB = cancel
        },

        // on ok execute
        onOk() {
            if (typeof this.callback != 'function') {
                this.isShow = false;
                return
            }

            const callback_Promise = this.callback();
            if (
                !(callback_Promise instanceof Promise)
                && Promise.resolve(callback_Promise) !== callback_Promise
            ) {
                //check first if callback is a promise, close dialog if not
                this.isShow = false
                return;
            }

            this.isProcessing = true
            try {
                callback_Promise
                .then((result) => {
                    //do something after
                })
                .catch(error => {
                    console.error('Error in callback:', error);
                })
                .finally(() => {
                    this.isShow = false
                    this.isProcessing = false;
                });
            } catch (error) {
                console.error('Callback failed:', error);
            }
        },

        // on cancel
        onCancel() {
            this.isShow = false
            this.isProcessing = false
            if (typeof this.cancelCB == 'function') {
                this.cancelCB()
            }
        },

        onReset() {
            this.isProcessing = false
        }
    }

}
</script>